export const constants = {
  id: 'usecases',
  name: 'Use Cases',
  title: 'Our Customers & Partners',
  thumb: process.env.PUBLIC_URL + '/asset/blue-cube.png',
};

export const usecases = [
  {
    id: 'mofa',
    // logo: 'logo/mofa.png',
    logo: 'https://github.com/RootChain-kr/rootchain-kr.github.io/blob/gh-pages/logo/mofa.png?raw=true',
    url: 'https://www.boannews.com/media/view.asp?idx=80236&page=149&kind=2',
    en: 'Establishment of authenticity verification service for financial power of attorney (notarization) issued by diplomatic missions abroad',
    ko: '재외공관에서 발급한 금융위임장(공증)에 대한 진본검증 서비스 구축',
  },
  {
    id: 'me',
    // logo: 'logo/me.png',
    logo: 'https://github.com/RootChain-kr/rootchain-kr.github.io/blob/gh-pages/logo/me.png?raw=true',
    url: 'http://www.itdaily.kr/news/articleView.html?idxno=94062',
    en: 'Transaction history of carbon credits is managed by blockchain to ensure transparency of transaction history',
    ko: '탄소배출권 거래 이력을 블록체인으로 관리하여 거래 이력에 대한 투명성 보장',
  },
  {
    id: 'motie',
    // logo: 'logo/motie.png',
    logo: 'https://github.com/RootChain-kr/rootchain-kr.github.io/blob/gh-pages/logo/motie.png?raw=true',
    url: 'http://www.epj.co.kr/news/articleView.html?idxno=21174',
    en: 'REC (Renewable Energy Certificates) Comprehensive Management System Expansion Establishment',
    ko: 'REC(Renewable Energy Certificates) 종합관리 시스템 확산 구축',
  },
  {
    id: 'busan',
    // logo: 'logo/busan.png',
    logo: 'https://github.com/RootChain-kr/rootchain-kr.github.io/blob/gh-pages/logo/busan.png?raw=true',
    url: 'dailysecu.com/news/articleView.html?idxno=120554',
    en: 'Establishment of blockchain-based city bus quasi-public accounting system (ERP)',
    ko: '블록체인 기반 시내버스 준공영제 회계공유시스템(ERP) 구축',
  },
  {
    id: 'kepco',
    // logo: 'logo/kepco.png',
    logo: 'https://github.com/RootChain-kr/rootchain-kr.github.io/blob/gh-pages/logo/kepco.png?raw=true',
    url: 'https://tvcc.kr/article/view/13593',
    en: 'KEPCO blockchain platform construction and service development',
    ko: 'KEPCO 블록체인 플랫폼 구축 및 서비스 개발',
  },
];
